import React, {Component} from 'react';
import Header from "../components/Header";
import {connectedSelector,userSelector} from "../redux/reducers/authReducer";
import connect from "react-redux/es/connect/connect";
import NotConnected from "../components/NotConnected";
import {checkToken} from "../redux/actionCreators/auth";
import BatteryMenu from "../components/BatteryMenu";
import {openBatterySelector} from "../redux/reducers/openReducer";
import strings from "../screenLocalisation/batteryInfo";
import {updateCellHistory, updateHistory} from "../redux/actionCreators/history";
import {lastCellStatesSelector} from "../redux/reducers/historyReducer";
import {dk_blue, dk_gray, dk_light_gray, dk_yellow} from "../constants/style";
import {PulseLoader} from "react-spinners";
import MaterialIcon from "material-icons-react";
import History from "../components/History";
import {myBatteriesSelector} from "../redux/reducers/myBatteriesReducer";
import {setOpenBattery} from "../redux/actionCreators/open";
import BatterySheet from "../components/BatterySheet";

//import BatteryMenu from "../components/BatteryMenu";

class Home extends Component {
    async componentDidMount() {
        await this.props.checkToken()
        if (!this.props.connected) {
            this.props.history.push('/login')
        } else if(this.props.user.isSuperAdmin) {
            this.props.history.push('/admin')
        }



    }

    getEQStatusIcon (eqStatus) {
        switch (eqStatus) {
            case 1: // 0
                return require('../assets/img/CELLS/BALANCING_OFF.png')
            case 2: // P
                return require('../assets/img/CELLS/BALANCING_PASSIVE.png')
            case 3: // A
                return require('../assets/img/CELLS/BALANCING_ACTIVE.png')

        }
    }

    normalise(value, min, max) {
        return (value - min) / (max - min)
    }

    async componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.openBattery != null && ((this.props.openBattery == null && nextProps.openBattery) || nextProps.openBattery.Battery_id !== this.props.openBattery.Battery_id)) {
            await this.props.updateHistory()
            this.props.updateCellHistory()
        }
        if (nextProps.myBatteries != null && nextProps.myBatteries.length > 0 && nextProps.openBattery == null) {
            //this.props.setOpenBattery(nextProps.myBatteries[0].Battery_id)
        }
    }

    render() {
        if (!this.props.connected) return null
        return (
            <div style={styles.container}>
                {/*<Header/>*/}
                <img style={styles.logo} src={require('../assets/img/logo_blue.png')}/>

                <BatteryMenu history={this.props.history}/>

                {this.props.openBattery ? this.renderBattery() : <BatterySheet/>}
            </div>
        );
    }

    renderBattery() {
        let {openBattery, cellStates} = this.props
        let hasCellData = false
        if (openBattery == null || openBattery.soc == null) {
            return null
        }


        cellStates = cellStates?cellStates.sort((a, b) => a.cell_id - b.cell_id):[]

        let max = null, min = null
        let diff = 0
        let cellTensionRange = {
            min: 3000,
            max: 3600
        }
        if(!(cellStates==null || cellStates.length === 0)) {
            hasCellData = true
            min = cellStates.reduce((prev, curr) => prev.ucell_avg<curr.ucell_avg?prev:curr)
            max = cellStates.reduce((prev, curr) => prev.ucell_avg>curr.ucell_avg?prev:curr)
                diff = max.ucell_avg - min.ucell_avg
                cellTensionRange = {
                    min: min.ucell_avg<cellTensionRange.min?min.ucell_avg:cellTensionRange.min,
                    max: max.ucell_avg>cellTensionRange.max?max.ucell_avg:cellTensionRange.max
                }


        }

        let okIcon = 'check'
        let onIcon = 'flash_on'
        let offIcon = 'flash_off'
        let errorIcon = 'error'

        return (
            <div style={styles.batteryInfo}>

                <h1>{openBattery.name}</h1>
                <h2>{openBattery.sn}</h2>

                {/*<div style={styles.seperationBar} />*/}

                <div className={'infoLists'}>
                    <div className={'infosBatteryDash'}>
                        <div  className={'scrollContainer'}>
                            <div style={styles.alertsInfo} className={'topInfoAlert'}>
                                <div className={'defaultIcon'}>
                                    {openBattery.tor_tempdefault||openBattery.tor_commdefault||  openBattery.tor_underchargedefault||openBattery.tor_overchargedefault||!openBattery.tor_noalarm ?
                                        <img src={require('../assets/img/DEFAULT/FAULT_ON.png')}/> :
                                        <img src={require('../assets/img/DEFAULT/FAULT_OFF.png')}/>}
                                </div>
                                <p>{strings.safetyDashboard}</p>
                            </div>
                            <div style={styles.alertsInfo}>

                                <div style={styles.dataGroup} className={'dataGroup'}>
                                    <div className={'safetyDashboardIcon'}>
                                        {openBattery.tor_overchargedefault ?
                                            <img src={require('../assets/img/DEFAULT/OVERCHARGE_ON.png')}/> :
                                            <img src={require('../assets/img/DEFAULT/OVERCHARGE_OFF.png')}/>}
                                    </div>
                                    <p>{strings.overcharge}</p>
                                </div>

                                <div style={styles.dataGroup} className={'dataGroup'}>
                                    <div className={'safetyDashboardIcon'}>
                                        {openBattery.tor_underchargedefault ?
                                            <img src={require('../assets/img/DEFAULT/UNDERCHARGE_ON.png')}/> :
                                            <img src={require('../assets/img/DEFAULT/UNDERCHARGE_OFF.png')}/>}
                                    </div>
                                    <p>{strings.undercharge}</p>
                                </div>
                                <div style={styles.dataGroup} className={'dataGroup'}>
                                    <div className={'safetyDashboardIcon'}>
                                        {openBattery.tor_tempdefault ?
                                            <img src={require('../assets/img/DEFAULT/OVERTEMP_ON.png')}/> :
                                            <img src={require('../assets/img/DEFAULT/OVERTEMP_OFF.png')}/>}
                                    </div>
                                    <p>{strings.temperature}</p>
                                </div>
                                <div style={styles.dataGroup} className={'dataGroup'}>
                                    <div className={'safetyDashboardIcon'}>
                                        {openBattery.tor_commdefault ?
                                            <img src={require('../assets/img/DEFAULT/COM_ERROR_ON.png')}/> :
                                            <img src={require('../assets/img/DEFAULT/COM_ERROR_OFF.png')}/>}
                                    </div>
                                    <p>{strings.communication}</p>
                                </div>
                            </div>
                        </div>
                        <div  className={'scrollContainer'}>
                            <div style={styles.alertsInfo} className={'topInfoAlert'}>
                                <p>{strings.title}</p>
                            </div>
                            <div className={'activesInfo'}>
                                <div className={'loadContainer'}>
                                    <p className={' batteryLoader'}>
                                        {'SOC : ' +openBattery.soc + '%'}
                                    </p>
                                    <div className={'loader'} style={{width: openBattery.soc + '%'}}/>
                                </div>
                                <div style={styles.dataGroup} className={'dataGroupText'}>
                                            <p >{(Math.floor((openBattery.upack_avg / 1000) * 100) / 100).toFixed(2)+' V'} </p>
                                </div>
                                <div style={styles.dataGroup}>
                                    <div>
                                        <div className={'safetyDashboardIcon'}>
                                            {openBattery.tor_chargeok ?
                                                <img src={require('../assets/img/DEFAULT/CHARGE_ON.png')}/> :
                                                <img src={require('../assets/img/DEFAULT/CHARGE_OFF.png')}/>}
                                        </div>
                                    </div>
                                    <p style={styles.dataTitle}>{strings.charge}</p>
                                </div>
                                <div style={styles.dataGroup}>
                                    <div>
                                        <div className={'safetyDashboardIcon'}>
                                            {openBattery.tor_dechargeok ?
                                                <img src={require('../assets/img/DEFAULT/DISCHARGE_ON.png')}/> :
                                                <img src={require('../assets/img/DEFAULT/DISCHARGE_OFF.png')}/>}
                                        </div>
                                    </div>
                                    <p style={styles.dataTitle}>{strings.discharge}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={'infosCellsDash'}>
                    <div style={styles.scrollContainer} className={'scrollContainer'}>
                        <div style={styles.alertsInfo} className={'topInfoAlert'}>
                            <p>{strings.cellTitle}</p>
                        </div>
                        <div className="infosCellsDashLegends">
                            <div className={'activesInfo cellsLabel'}>
                                <div style={styles.dataGroup} className={'dataGroupText dataGroupRow cellTitle'}>
                                    <p>{strings.cellShortTitle}</p>
                                </div>
                                <div style={styles.dataGroup} className={' dataGroupText dataGroupRow cellGap'}>
                                    <img src={require('../assets/img/CELLS/VOLTAGE_GAP.png')}/>
                                    <div className={'cellGapText'}>
                                        <p style={styles.dataTitle}>{strings.differences}</p>
                                        {hasCellData ? <p style={styles.dataValue}>{diff} mV</p> :
                                            <div style={styles.dataLoader}><PulseLoader color={dk_blue} size={10}/></div>}
                                    </div>
                                </div>
                                <div style={styles.dataGroup} className={'dataGroupText dataGroupRow balancingState'}>
                                    <p>{strings.balancingState}</p>
                                </div>
                            </div>
                            <div className={'activesInfo'}>
                                <div style={styles.dataGroup} className={'dataGroupText dataGroupRow cellTitle'}>
                                    <p>{strings.cellShortTitle}</p>
                                </div>
                                <div style={styles.dataGroup} className={' dataGroupText dataGroupRow cellGap'}>
                                    <img src={require('../assets/img/CELLS/VOLTAGE_GAP.png')}/>
                                    <div className={'cellGapText'}>
                                        <p style={styles.dataTitle}>{strings.differences}</p>
                                        {hasCellData ? <p style={styles.dataValue}>{diff} mV</p> :
                                            <div style={styles.dataLoader}><PulseLoader color={dk_blue} size={10}/></div>}
                                    </div>
                                </div>
                                <div style={styles.dataGroup} className={'dataGroupText dataGroupRow balancingState'}>
                                    <p>{strings.balancingState}</p>
                                </div>
                            </div>
                        </div>

                        <div style={styles.cellsInfo} className={'cellsInfo'}>
                            {hasCellData ?
                                cellStates.map((cell, i) => (
                                    <div key={cell.id} className={'cellRow'}>
                                        <div className={'cellRowColumn cellColumnName'}>
                                            <img src={require('../assets/img/CELLS/CELL_'+(i+1)+'.png')}/>
                                        </div>
                                        <div className={'cellRowColumn cellRowLoader'}>
                                            <div className={'loadContainer'}>
                                                <div className={'minMax'}>{cell.cell_id === min.cell_id ? "MIN  ":null}
                                                {cell.cell_id === max.cell_id ? "MAX  ":null}
                                                </div>
                                                <p className={' cellRowLoader'}>
                                                    {cell.ucell_avg + ' mV' + ' / ' + cell.temp + ' °C'}
                                                </p>
                                                <div className={'loader'} style={{width: this.normalise(cell.ucell_avg, cellTensionRange.min, cellTensionRange.max)*100+'%'}}/>
                                            </div>
                                        </div>
                                        <div className={'cellRowColumn'}><p className={' cellRowState'}>
                                            <img src={this.getEQStatusIcon (cell.EQ_Status_id)}/>
                                            </p></div>
                                    </div>
                                ))
                                :
                                <PulseLoader color={dk_blue} size={10}/>
                            }
                        </div>
                    </div>
                    </div>

                </div>

                <History key={openBattery.id}/>
            </div>
        )
    }
}

let valueGrid
if (window.innerWidth > 1330) {
    valueGrid = '25% 25% 25% 25%'
} else if (window.innerWidth > 850) {
    valueGrid = '50% 50%'
} else {
    valueGrid = '100%'
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row'
    },
    batteryInfo: {
        flex: 1,
        padding: 10,
        paddingTop: 65,
        width: '100%'
    },
    dataGroup: {
        flex: 1,
        textAlign: 'center'
    },
    scrollContainer: {
        flex: 1,
        marginRight: 10,
        marginLeft: 10,
        marginTop: 10
    },
    dataTitle: {
        flex: 1,
        marginRight: 20,
        margin: 0,
        height: 10,
        paddingBottom: 5,
        fontSize:13
    },
    dataValue: {
        flex: 1,
        margin: 0,
        height: 20,
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: dk_light_gray,
        paddingBottom: 5,
        paddingTop: 5,
        gridColumnEnd: 'span 2'
    },
    dataLoader: {
        flex: 1,
        height: 17
    },
    infoLists: {
        display: 'grid',
        gridTemplateColumns: valueGrid,
        // gridTemplateRows: window.innerWidth>1000?'25% 25% 25% 25%':'50% 50%',
        marginTop: 20,
        marginBottom: 20,
    },
    overallInfo: {
        flex: 1
    },
    cellsInfo: {
        flex: 1
    },
    alertsInfo: {
        display: `flex`,
        padding: 15
    },
    activesInfo: {
        flex: 1
    },
    seperationBar: {
        height: 20,
        marginTop: 20,
        marginBottom: 20,
        backgroundColor: dk_yellow
    },
    logo: {
        position: 'absolute',
        top: 15,
        right: 15,
        height: 75,
    }
}

const mapStateToProps = state => ({
    connected: connectedSelector(state),
    openBattery: openBatterySelector(state),
    cellStates: lastCellStatesSelector(state),
    myBatteries: myBatteriesSelector(state),
    user: userSelector(state)
})

export default connect(mapStateToProps, {checkToken, updateCellHistory, updateHistory, setOpenBattery})(Home);